import Button from "@components/Button/Button";
import {
  ButtonSize,
  KeywordWithFollowTextProps,
} from "@components/Button/utils/types";
import { faCheck, faPlus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@util/helpers";

export default function KeywordButtonVersion2({
  handleClick,
  isTagFollowed,
  isLoading,
  iconClassName,
  className,
}: KeywordWithFollowTextProps): React.ReactElement {
  return (
    <Button
      onClick={handleClick}
      className={cn(
        "ml-auto flex aspect-square cursor-pointer items-center justify-center whitespace-nowrap rounded-full !border !border-solid !border-gray-175 px-3 text-center !font-poppins text-xs font-semibold leading-150 tracking-2 text-gray-850 !outline-none transition-all duration-150 focus-within:outline-none hover:!border-gray-850 focus:outline-none data-[size=lg]:h-[68px] data-[size=md]:h-[42px] data-[size=sm]:h-[36px] md:aspect-auto md:px-6",
        { "border-gray-850": isTagFollowed },
        className
      )}
      buttonSize={ButtonSize.medium}
      aria-label={"Follow tag"}
      testId="keyword-button-component"
    >
      {!isLoading && !isTagFollowed ? (
        <div className="md:min-w-16">
          <p className="m-0 hidden md:block">Follow</p>
          <div className="flex items-center md:hidden">
            <FontAwesomeIcon
              icon={faPlus}
              spin={isLoading}
              size="sm"
              color="text-gray-850"
              className={iconClassName}
            />
          </div>
        </div>
      ) : (
        <div className="md:min-w-16">
          {isTagFollowed && !isLoading ? (
            <>
              <p className="m-0 hidden md:block">Following</p>

              <div className="flex items-center md:hidden">
                <FontAwesomeIcon
                  icon={faCheck}
                  spin={isLoading}
                  size="sm"
                  color="text-gray-850"
                  className={iconClassName}
                />
              </div>
            </>
          ) : null}

          {!isTagFollowed || isLoading ? (
            <FontAwesomeIcon
              icon={isLoading ? faSpinner : isTagFollowed ? faCheck : faPlus}
              spin={isLoading}
              size="sm"
              color="text-gray-850"
              className={iconClassName}
            />
          ) : null}
        </div>
      )}
    </Button>
  );
}
